import { FIND_ASSIGNABLE_ASSET_ROUTINES } from '@gripp/shared-logic';
import { InfiniteDataGrid } from '@gripp/shared-ui';
import { ColumnDef } from '@tanstack/react-table';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useRoutineColumns } from '../../new-routines/components/useRoutineColumns';

export type EditAssetRoutinesListProps = {
  workspaceId: string;
  assetId: string;
  maxHeight?: number;
  keyword?: string;
  assignments: string[];
  updateAssignments: (assignments: string[]) => void;
};

export const EditAssetRoutinesList = ({
  workspaceId,
  assetId,
  maxHeight,
  keyword,
  assignments,
  updateAssignments,
}: EditAssetRoutinesListProps) => {
  const { t } = useTranslation();
  const filter = useMemo(() => {
    if (!workspaceId) return undefined;
    
    return {
      keyword,
      assetId,
      routines: assignments,
      workspaceId,
    };
  }, [keyword, assetId, workspaceId]);
  
  const columns = useRoutineColumns() as ColumnDef<any, any>[];

  if (!filter) return null;

  return (
    <InfiniteDataGrid
      modelName="routine"
      hideResultsLabel={true}
      query={FIND_ASSIGNABLE_ASSET_ROUTINES}
      filter={filter}
      orderBy={{ field: 'name', order: 'ASC' as any }}
      pageSize={100}
      columns={columns}
      listMaxHeight={maxHeight as number}
      containerStyle={{ height: maxHeight }}
      paddingBottom={0}
      textEmpty={t('routines.textEmpty')}
      dataPrefix="routine.findAssignableAssetRoutines"
      updateRowsSelected={(rows) => {
        updateAssignments(rows.map(row => row.id));
      }}
      isRowSelected={(row) => {
        return assignments.includes(row.id);
      }}
      enableScrollRefresh={true}
      showScrollIndicator={true}
    />
  );
};
